<template>
  <div class="bg-bgr-primary flex flex-col overflow-hidden rounded-xl">
    <slot />
  </div>
</template>

<script setup lang="ts">
  defineOptions({
    name: "GlobalSearchContainer",
  });
</script>
